export { Point, LengthPoints } from "./NodeDXF/Point";
import { BIGNUMEBR, SMALLNUMBER } from "./nodedxf2";
export class Contour {
    constructor() {
        this.min = { x: BIGNUMEBR, y: BIGNUMEBR };
        this.max = { x: SMALLNUMBER, y: SMALLNUMBER };
        this.width = 0;
        this.height = 0;
        this.canvas_width = 0;
        this.canvas_height = 0;
        this.Cuts = { qty: 0, totallen: 0 };
        this.Bends = { qty: 0, totallen: 0 };
        this.scaleY = (y) => {
            const offsetY = this.min.y - this.height / 2;
            return ((this.height - y + offsetY) * this.scalefator + this.canvas_height / 2);
        };
        this.reverseScaleY = (scaledY) => {
            const offsety = this.min.y - this.height / 2;
            return (this.height +
                offsety -
                (scaledY - this.canvas_height / 2) / this.scalefator);
        };
        this.scaleX = (x) => {
            const offsetX = this.min.x - this.width / 2;
            return this.canvas_width / 2 - (this.width - x + offsetX) * this.scalefator;
        };
        this.reverseScaleX = (scaledX) => {
            const offsetX = this.min.x - this.width / 2;
            return (this.width + offsetX - (this.canvas_width / 2 - scaledX) / this.scalefator);
        };
        this.reverseScale = (scaledPoint) => {
            let unscaledPoint = Object.assign({}, scaledPoint);
            unscaledPoint.x = this.reverseScaleX(unscaledPoint.x);
            unscaledPoint.y = this.reverseScaleY(unscaledPoint.y);
            return unscaledPoint;
        };
        this.scale = (e) => {
            e = Object.assign({}, e);
            e.x = this.scaleX(e.x);
            e.y = this.scaleY(e.y);
            return e;
        };
    }
}
